var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C9.5 14.5 5.33333 17 4 18L5.5 31.5H25L26 18C21 18 20.5 15.5 15 15Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.48 3.5C9.55454 3.5 8.79999 4.25228 8.79999 5.19C8.79999 6.01843 8.12841 6.69 7.29999 6.69C6.47156 6.69 5.79999 6.01843 5.79999 5.19C5.79999 2.60772 7.88543 0.5 10.48 0.5H19.52C22.1084 0.5 24.21 2.60157 24.21 5.19C24.21 6.01843 23.5384 6.69 22.71 6.69C21.8816 6.69 21.21 6.01843 21.21 5.19C21.21 4.25843 20.4516 3.5 19.52 3.5H10.48Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86504 9.50609C3.69011 9.43156 4.41937 10.04 4.49389 10.8651L6.17417 29.4682C6.22575 30.0527 6.71619 30.5 7.29997 30.5H22.7C23.2838 30.5 23.7742 30.0527 23.8258 29.4682L23.8261 29.4651L25.5061 10.8651C25.5806 10.04 26.3098 9.43156 27.1349 9.50609C27.96 9.58061 28.5684 10.3099 28.4939 11.1349L26.8142 29.7318C26.8141 29.7327 26.814 29.7337 26.8139 29.7346C26.6242 31.8687 24.8353 33.5 22.7 33.5H7.29997C5.16433 33.5 3.37515 31.8681 3.18593 29.7336C3.18588 29.733 3.18583 29.7324 3.18578 29.7318L1.50605 11.1349C1.43153 10.3099 2.03997 9.58061 2.86504 9.50609Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6.19C0.5 5.36158 1.17157 4.69 2 4.69H28C28.8284 4.69 29.5 5.36158 29.5 6.19C29.5 7.01843 28.8284 7.69 28 7.69H2C1.17157 7.69 0.5 7.01843 0.5 6.19Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.0af388213bb726159b778bf50d709b39.svg";
export { ForwardRef as ReactComponent };